import { useAuth } from 'contexts/AuthContext'
import { useState } from 'react'
import { useSignUpPage } from '../SignUpPage/logic'
import * as EmailValidator from 'email-validator'
import { Wrapper } from 'styles/styleSystem/wrapper'
import { Bubble } from 'components/Bubble'
import { Input } from 'components/Input'
import { INPUT_VARIANTS } from 'components/Input/types'
import {
  NewsletterCheckboxWrapper,
  PasswordCheckWrap,
  PasswordRequirementsWrap,
} from '../SignUpPage/styles'
import { FaCheck } from 'react-icons/fa'
import { Text } from 'components/Text'
import { Button, BUTTON_VARIANTS } from 'components/Button'
import { Tooltip } from 'antd'
import { useRouter } from 'next/router'
import { passwordRequirements } from '../helpers'
import _isString from 'lodash-es/isString'

export const SignUpForm = ({ setSection = null }) => {
  const { signup } = useAuth()
  const {
    handleSubmit,
    email,
    handleEmailChange,
    password,
    confirmPassword,
    handlePasswordChange,
    handleConfirmPasswordChange,
    joinNewsletter,
    handleJoinNewsLetterChange,
    loading,
    error,
  } = useSignUpPage(signup)
  const router = useRouter()
  const [showPasswordRequirements, setShowPasswordRequirements] =
    useState(false)
  const [signUpPressed, setSignUpPressed] = useState(false)

  const validPassword =
    passwordRequirements(password).filter((req) => !req.checked).length === 0
  const validatedJoin =
    validPassword &&
    EmailValidator.validate(email) &&
    confirmPassword === password

  const setErrorMessageText = () => {
    let message = 'Invalid Information'
    if (!validatedJoin) {
      if (!validPassword) {
        message = 'Invalid password'
      } else if (confirmPassword !== password) {
        message = 'Passwords do not match'
      }
      if (!EmailValidator.validate(email)) {
        message = 'Please enter a valid email'
      }
    }
    return message
  }

  const formSubmit = (e) => {
    setSignUpPressed(true)
    handleSubmit(e)
  }

  return (
    <form onSubmit={formSubmit}>
      {!validatedJoin && signUpPressed && (
        <Wrapper mb={3}>
          <Bubble text={setErrorMessageText()} />
        </Wrapper>
      )}
      <Wrapper spacing={15}>
        <Wrapper relative>
          <Input
            alt="email"
            variant={INPUT_VARIANTS.label}
            placeholder="user@gmail.com"
            value={email}
            onChange={handleEmailChange}
            label="Email"
          />
          {EmailValidator.validate(email) && (
            <PasswordCheckWrap>
              <FaCheck color="green" />
            </PasswordCheckWrap>
          )}
        </Wrapper>
        <Wrapper relative>
          <Input
            alt="password"
            variant={INPUT_VARIANTS.label}
            value={password}
            type="password"
            placeholder="∗∗∗∗∗∗∗"
            onChange={handlePasswordChange}
            onFocus={() => setShowPasswordRequirements(true)}
            onBlur={() => setShowPasswordRequirements(false)}
            label="Password"
          />
          {validPassword && (
            <PasswordCheckWrap>
              <FaCheck color="green" />
            </PasswordCheckWrap>
          )}
        </Wrapper>
      </Wrapper>
      {showPasswordRequirements && (
        <PasswordRequirementsWrap>
          <div>
            {passwordRequirements(password).map((requirement) => (
              <Wrapper
                key={requirement.title}
                spacing={10}
                display="flex"
                alignItems="center"
                horizontal
              >
                <Text
                  size="lg"
                  weight={requirement.checked ? 'base' : 'light'}
                  color={requirement.checked ? 'primary' : 'secondary'}
                >
                  {requirement.title}
                </Text>
                {requirement.checked && <FaCheck color="green" />}
              </Wrapper>
            ))}
          </div>
        </PasswordRequirementsWrap>
      )}
      <Wrapper mt={15} relative>
        <Input
          alt="password"
          variant={INPUT_VARIANTS.label}
          value={confirmPassword}
          type="password"
          placeholder="∗∗∗∗∗∗∗"
          onChange={handleConfirmPasswordChange}
          label="Confirm Password"
        />
        {confirmPassword === password && validPassword && (
          <PasswordCheckWrap>
            <FaCheck color="green" />
          </PasswordCheckWrap>
        )}
      </Wrapper>
      <Wrapper mt={30}>
        <Tooltip title={!validatedJoin ? setErrorMessageText() : null}>
          <div>
            <Button
              size="lg"
              fullWidth
              variant={BUTTON_VARIANTS.primary}
              label="Join"
              loading={loading}
              disabled={!validatedJoin || loading}
            />
          </div>
        </Tooltip>
      </Wrapper>
      {_isString(error) ? <Bubble type="error" text={error} /> : null}
      <Wrapper
        my={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <NewsletterCheckboxWrapper>
          <Input
            label="Also join the Fintros Newsletter"
            variant={INPUT_VARIANTS.checkbox}
            enabled={joinNewsletter}
            handleChange={handleJoinNewsLetterChange}
          />
        </NewsletterCheckboxWrapper>
      </Wrapper>
      <div>
        <Text size="md" weight="light" color="secondary" align="center">
          By clicking the &quot;Join&quot; button, you are creating a Fintros
          account, and you agree to Fintros Terms of Use and Privacy Policy.
          Data Security, Privacy, and Terms.
        </Text>
      </div>
      <Wrapper
        mt={30}
        mb={4}
        spacing={5}
        display="flex"
        alignItems="center"
        justifyContent="center"
        horizontal
      >
        <Text size="md" weight="light" color="secondary">
          Already have an account?
        </Text>
        <Text
          hover
          weight="base"
          onClick={() =>
            setSection ? setSection('login') : router.push('/login')
          }
        >
          Login.
        </Text>
      </Wrapper>
    </form>
  )
}
